import { Injectable, inject } from '@angular/core';
import {LorenAdminRole} from '../../interfaces/loren-admin-role.interface';
import {environment} from '../../../../../../environments/environment';
import {Observable} from 'rxjs';
import {GenericItems} from '../../../../../shared/interfaces/generic-items.interface';
import {map} from 'rxjs/operators';
import {LorenRole} from '../../../../loren-roles/interfaces/loren-role.interface';
import { HttpClient } from "@angular/common/http";

@Injectable({
    providedIn: 'root'
})
export class LorenAdminRolesService {
    protected http = inject(HttpClient);

    userRoleToTranslationKeyMap = new Map<string, string>([
        ['ROLE_USER', 'account.user_role'],
        ['ROLE_ADMIN_FULL', 'account.admin_role_full'],
        ['ROLE_ADMIN_READ', 'account.admin_role_read'],
        ['ROLE_COMPANY_ADMIN', 'account.admin_role_company_admin'],
        ['ROLE_CHANNEL_ADMIN', 'account.admin_role_channel_admin'],
        ['ROLE_CHANNEL_ADMIN_READ', 'account.admin_role_channel_admin_read']
    ]);

    getAdminRoles(): Observable<LorenAdminRole[]> {
        return this.http.get<GenericItems<LorenAdminRole>>(`${environment.apiServerUrl}/roles`, {})
            .pipe(
                map(res => {
                    return res.items.map(r => ({
                        id: r.id,
                        displayName: r.name,
                        name: r.name
                    }));
                })
            );
    }

    getAccountRoles(companyId: number): Observable<LorenRole[]> {
        return this.http.get<GenericItems<LorenRole>>(`${environment.apiServerUrl}/company-user-roles?companyId=${companyId}`, {})
            .pipe(
                map(res => res.items)
            );
    }
}
